import React from 'react';
import Draggable from 'react-draggable';
import { DownloadCVDiv } from './../styled/DownloadCV.styled';
import cv from '../../assets/CV.pdf'
import { personalInformationData } from '../../data';

const DownloadCV = () => {
    const nodeRef = React.useRef(null);
    return (
        <Draggable bounds="body" nodeRef={nodeRef}>
            <DownloadCVDiv ref={nodeRef}>
                <a href={cv} download={`${personalInformationData.name} CV.pdf`}>Download CV</a>
            </DownloadCVDiv>
        </Draggable>
    );
};

export default DownloadCV;